import styled from 'styled-components';

import { PrimaryButton } from 'brand-guidelines/Buttons-styled-components';
import { BRAND_COLORS } from 'brand-guidelines/colors';
import { TYPOGRAPHY } from 'brand-guidelines/typography';
import { BaseBodyText } from 'pages/checkout-v3/components/common/typographic-styled-components';

export const FormFieldsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 12px;
`;

export const SubmitButton = styled(PrimaryButton).attrs({ type: 'submit' })`
  width: 100%;
  padding: 8px 32px;
  font-size: 14px;
  line-height: 24px;
`;

export const DividerWithText = styled(BaseBodyText).attrs({ as: 'div' })`
  display: flex;
  align-items: center;
  gap: 16px;
  width: 100%;

  &::before,
  &::after {
    content: '';
    flex: 1;
    border-top: 1px solid ${BRAND_COLORS.stroke};
  }
`;

export const LoginText = styled(BaseBodyText).attrs({ as: 'p' })`
  ${TYPOGRAPHY.CIRCULAR.book}
  line-height: 24px;
  color: ${BRAND_COLORS.black};
  text-align: center;
`;

export const AlternateLoginSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 16px;

  /* Compensate gap of 24px between form and alternate login section */
  margin-top: -8px;
`;
